import { Injectable } from '@angular/core';
import { PuzzleSettingsModalComponent } from './puzzle-settings-modal.component';
import { PuzzleFrameworkService } from '../../puzzle-framework-module/puzzle-framework.service';
import { AlertController, ModalController } from '@ionic/angular/standalone';
import { TranslateService } from '@ngx-translate/core';

import { Button } from '../buttons/button.def';

import { LeaderboardService } from 'projects/tools/src/lib/shared-module/leaderboard/leaderboard.service';

@Injectable({
  providedIn: 'root',
})
export class PuzzleSettingsModalService {
  constructor(
    private framework: PuzzleFrameworkService,
    private ionicModal: ModalController,
    private ionicAlert: AlertController,
    private translate: TranslateService,
    private leaderboard: LeaderboardService
  ) {
    this.framework.buttonPressed.subscribe((button) => {
      if (button === Button.SettingsMenu) {
        this.openSettingsMenu();
      }
    });
  }

  public async openSettingsMenu() {
    const modal = await this.ionicModal.create({
      component: PuzzleSettingsModalComponent,
      backdropDismiss: true,
      cssClass: 'puzzle-modal',
    });

    if (this.leaderboard.canPauseSilently()) {
      this.framework.pauseCurrentGame();
    }

    await modal.present();
    const modalResult = await modal.onDidDismiss<boolean>();

    // check if reset button is pressed
    if (!modalResult.data) {
      // exit if user just closed
      this.framework.resumeCurrentGame();
      return;
    }

    // show confirmation dialog, either open the settings modal again or invoke settings reset
    const resolved = await Promise.all([
      this.translate.get('PUZZLE.settings_modal.reset_dialog.title').toPromise(),
      this.translate.get('PUZZLE.settings_modal.reset_dialog.message').toPromise(),
      this.translate.get('PUZZLE.dialog.button.no').toPromise(),
      this.translate.get('PUZZLE.dialog.button.yes').toPromise(),
      this.translate.get('PUZZLE.settings_modal.reset_dialog.warning').toPromise(),
    ]);

    // return new Promise<boolean>(resolve => {
    const alert = await this.ionicAlert.create({
      header: resolved[0],
      subHeader: resolved[4],
      message: resolved[1],
      backdropDismiss: false,
      cssClass: 'puzzle-alert',
      buttons: [
        {
          text: resolved[2],
          role: 'cancel',
          cssClass: 'primary',
        },
        {
          text: resolved[3],
          role: 'confirm',
          cssClass: 'primary',
        },
      ],
    });

    await alert.present();

    const alertResult = await alert.onDidDismiss();

    this.framework.resumeCurrentGame();

    if (alertResult.role === 'confirm') {
      // this.store.dispatch(new RevokeConsent());
      if (this.leaderboard.resetToLeaderboardSettings) {
        await this.leaderboard.initDefaultSettings(true);
      } else {
        await this.framework.initDefaultSettings(true);
      }
    }

    await this.openSettingsMenu();
  }
}
